import { useEffect } from "react";
import { SITE } from "@/lib/site";

/**
 * Renders the exact LeadConnector (GHL) website form as provided by the client.
 * The embed is used identically in the hero and the "Get Free Estimate" popup —
 * no forced heights, no restyling, natural widget appearance preserved.
 *
 * The iframe sits inside an in-flow wrapper that reserves its height. This
 * matters because form_embed.js re-parents the iframe to position:absolute
 * during its handshake, at which point a height on the iframe itself reserves
 * nothing — the wrapper measured 0px tall on the live site, so everything below
 * the form jumped once it resolved. Reserve values come from the widget's own
 * iFrameSizer handshake (705px at >=420px wide, 725px narrower), not from the
 * data-height attribute, which reported 666 and was simply wrong.
 */
const FORM_EMBED_SCRIPT = "https://link.systemic-digital.net/js/form_embed.js";

const EmbeddedForm = ({ className = "" }: { className?: string }) => {
  useEffect(() => {
    // Load the LeadConnector form embed script once; it hydrates all iframes on the page.
    if (document.querySelector(`script[src="${FORM_EMBED_SCRIPT}"]`)) return;
    const s = document.createElement("script");
    s.src = FORM_EMBED_SCRIPT;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div className="form-embed-reserve">
      <iframe
        src={SITE.formSrc}
        style={{ width: "100%", border: "none", borderRadius: "10px" }}
        id={`inline-${SITE.formId}`}
        data-layout="{'id':'INLINE'}"
        data-trigger-type="alwaysShow"
        data-trigger-value=""
        data-activation-type="alwaysActivated"
        data-activation-value=""
        data-deactivation-type="neverDeactivate"
        data-deactivation-value=""
        data-form-name="Website Form"
        data-height="705"
        data-layout-iframe-id={`inline-${SITE.formId}`}
        data-form-id={SITE.formId}
        title="Website Form"
        className={className}
      />
    </div>
  );
};

export default EmbeddedForm;
